module.exports = __webpack_public_path__ + "static/img/group.01ec069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/group.png
// module id = B7jq
// module chunks = 6